import * as React from 'react'
import { InviteCardConnected } from './InviteCardConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore, MOCK_INVITE_A_ID } from 'mockState'

export const InviteCardExamples = () => {
  return (
    <div className="InviteCardExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <InviteCardConnected inviteId={MOCK_INVITE_A_ID} />
      </Provider>
    </div>
  )
}
